import { axiosMarketplace } from "../../services/axios";

const getCategories = async () => {
  const res = await axiosMarketplace.get("/category");
  return res.data;
};

export default getCategories;
